export default {
    'add-new-vacation': 'إضافة عطلة جديدة',
    'recurring-leave': 'إجازة مكررة',
    'one-time-leave': 'إجازة لمرة واحدة',
    'add-vacation': 'إضافة عطلة',
    'edit-vacation': 'تعديل عطلة',
    'is-constant': 'ثابتة',
    'this-vacation': 'هذه العطلة'
}